import React, { useState } from 'react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { AccountReviewState } from './AccountReview.state';
import {
    AccountReviewButton,
    AccountReviewFormWrapper,
    AccountReviewParagraph,
    AccountReviewStatusContainer,
    AccountReviewNextDate,
    SectionHeader,
} from './AccountReview.style';
import { observer } from 'src/utils/mobx-react';
import { SelectNew } from 'src/domains/players/webview/components/form/selectNew/SelectNew';
import { Messages } from 'src/domains/layouts/webview/components/Messages/Messages';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { useCommon } from 'src/domains/common/Common';

export const AccountReview = observer('AccountReview', () => {
    const common = useCommon();
    const languagesState = LanguagesState.get(common);
    const [state] = useState(() => new AccountReviewState(languagesState, common));

    return (
        <AccountReviewFormWrapper
            isMessage={state.showInfo}
            data-test='account-review'
        >
            <SectionHeader data-test='account-review-header'>
                <I18n
                    langKey='account.account-review.title'
                    defaultText='Account Review'
                />
            </SectionHeader>
            <AccountReviewParagraph data-test='account-review-paragraph'>
                <I18n
                    langKey='account.account-review.description'
                    defaultText="Choose how often you'd like to be reminded to review your account activity, transactions and limits."
                />
            </AccountReviewParagraph>

            <AccountReviewStatusContainer></AccountReviewStatusContainer>

            <>
                <SelectNew
                    dataTest='account-review-select'
                    options={state.accountReviewOptions}
                    inputState={state.accountReviewInput}
                    placeholder={languagesState.getTranslation(
                        'account.account-review.duration.label',
                        'Choose account review frequency'
                    )}
                />

                {state.nextReviewDate !== null && (
                    <div data-test='next-review-date'>
                        <I18n
                            langKey='account.account-review.next-review-date'
                            defaultText='Next review:'
                        />{' '}
                        <AccountReviewNextDate>{state.nextReviewDate}</AccountReviewNextDate>
                    </div>
                )}

                <AccountReviewButton
                    type='submit'
                    size='medium'
                    onClick={state.onSubmitaccountReviewForm}
                    dataTest='account-review-save-button'
                    isLoading={state.loader}
                >
                    <I18n
                        langKey='account.account-review.submit.label'
                        defaultText='Save'
                    />
                </AccountReviewButton>

                {state.showInfo && (
                    <Messages
                        marginTop='8px'
                        type='success'
                        message={
                            <I18n
                                langKey='account.account-review.success-message'
                                defaultText='Changes saved successfully.'
                            />
                        }
                    />
                )}
            </>
        </AccountReviewFormWrapper>
    );
});
